import {BeneficiaryPerson} from 'Beneficiaries/models/BeneficiaryPerson';
import {Async, Empty, Loaded} from 'Core/models/Async';
import {createAction} from 'Shared/utilities/actionCreator';

export enum BeneficiaryDetailActionTypes {
  FETCH_BENEFICIARY_DETAILS = 'beneficiaries/details/FETCH_BENEFICIARY_DETAILS',
  CHANGE_BENEFICIARY_DETAILS = 'beneficiaries/details/CHANGE_BENEFICIARY_DETAILS',
  DELETE_BENEIFICIARY_PERSON = 'beneficiaries/details/DELETE_BENEIFICIARY_PERSON',
  UPDATE_BENEFICIARY_DETAILS = 'beneficiaries/details/UPDATE_BENEFICIARY_DETAILS',
  VALIDATE_AND_SAVE_BENEFICIARY_POLICY = 'beneficiaries/details/VALIDATE_AND_SAVE_BENEFICIARY_POLICY',
}

export const fetchBeneficiaryDetails = (policyNumber: string) =>
  createAction(BeneficiaryDetailActionTypes.FETCH_BENEFICIARY_DETAILS, {
    policyNumber,
  });

export const changeBeneficiaryDetails = (beneficiaryDetails: Async<BeneficiaryPerson[]>) =>
  createAction(BeneficiaryDetailActionTypes.CHANGE_BENEFICIARY_DETAILS, {beneficiaryDetails});

export const deleteBeneficiaryPerson = (beneficiaryId: string, id: string) =>
  createAction(BeneficiaryDetailActionTypes.DELETE_BENEIFICIARY_PERSON, {policyNumber: beneficiaryId, id});

// This is for Walmart Beneficiaries, any updates goes here
export const updateBeneficiaryDetails = (beneficiaryDetails: Async<BeneficiaryPerson[]>) =>
  createAction(BeneficiaryDetailActionTypes.UPDATE_BENEFICIARY_DETAILS, beneficiaryDetails);

export const validateAndSaveBeneficiaryPolicy = (beneficiaryDetails: BeneficiaryPerson[], policyNumber: string) =>
  createAction(BeneficiaryDetailActionTypes.VALIDATE_AND_SAVE_BENEFICIARY_POLICY, {beneficiaryDetails, policyNumber});

type BeneficiaryDetailActions =
  | ReturnType<typeof changeBeneficiaryDetails>
  | ReturnType<typeof updateBeneficiaryDetails>;

type BeneficiaryDetailState = {
  beneficiaryDetails: Async<BeneficiaryPerson[]>;
  originalBeneficiaryDetails: Async<BeneficiaryPerson[]>;
};

export const DEFAULT_STATE = {
  beneficiaryDetails: new Empty(),
  originalBeneficiaryDetails: new Empty(),
};

export default (
  state: BeneficiaryDetailState = DEFAULT_STATE,
  action: BeneficiaryDetailActions
): BeneficiaryDetailState => {
  switch (action.type) {
    case BeneficiaryDetailActionTypes.CHANGE_BENEFICIARY_DETAILS:
      return {
        ...state,
        beneficiaryDetails: action.payload.beneficiaryDetails,
        originalBeneficiaryDetails:
          action.payload.beneficiaryDetails.key === 'Loaded'
            ? new Loaded([...action.payload.beneficiaryDetails.Data])
            : action.payload.beneficiaryDetails,
      };
    case BeneficiaryDetailActionTypes.UPDATE_BENEFICIARY_DETAILS:
      return {
        ...state,
        beneficiaryDetails: action.payload,
      };
    default:
      return state;
  }
};
